// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Text from "components/typography/Text";

// ** Styles Import
import { StyledLandingButton } from "containers/Landing/styles/LandingButton.styled";

// #####################################################

const GenderButtonStyled = styled(StyledLandingButton)`
	padding: 0.125rem;
	background-color: var(--dz-sys-button-landing-secondary-background-color);
	color: var(--dz-sys-button-landing-secondary-text-color);
	box-shadow: var(--dz-comp-auth-panel-box-shadow);

	button[disabled] {
		cursor: no-drop;
	}

	&:hover {
		background-color: var(
			--dz-sys-button-landing-secondary-background-color-hover
		);
	}

	${({ active }) =>
		active &&
		css`
			background-color: var(
				--dz-sys-button-landing-secondary-background-color-active
			);
			color: var(--dz-sys-button-landing-secondary-text-color);
			font-weight: bold;
		`}
`;

const GenderButton = ({ onClick, active, label, ...props }) => {
	// #####################################################

	return (
		<GenderButtonStyled
			onClick={onClick}
			active={active}
			label={label}
			{...props}
		>
			<Text px={2}>{label}</Text>
		</GenderButtonStyled>
	);
};

// #####################################################

export default GenderButton;

// #####################################################
